import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PriceList from "./pages/PriceList";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lista-de-precios" element={<PriceList />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
